/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate, useParams } from "react-router-dom";
import { RoutedModal } from "../../../../components/common";
import { pathConstants } from "../../../../routes/pathContants";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useEffect } from "react";
import secondaryComponents from "../../../../components/secondaryComponents";
import useAllCustomers from "../../../appPages/Customers/AllCustomers/useAllCustomers";
import { PlusIcon } from "../../../../assets/svgIcons";

export const SMCustomersHome = () => {
  const navigate = useNavigate();
  const { store_id } = useParams();
  const {
    customers,
    isFetchingCustomers,
    metaDetails,
    search,
    isCustomerWidget,
    searchCustomers,
    gotoPage,
    setSearch,
    setIsCustomerWidget,
  } = useAllCustomers();

  useEffect(() => {
    if (!search.get("store_id")) {
      search.set("store_id", search.get("store_id") || store_id);
      setSearch(search, { replace: true });
    }
  }, []);

  return (
    <RoutedModal
      isActive={true}
      headerTitle="Customers"
      headerDescription="Manage & view your customers and track their purchases & preferences"
      closeModal={() =>
        navigate(pathConstants.SELL_MODE({ store_id: store_id }))
      }
    >
      <primaryComponents.Button
        onClick={() => {
          setIsCustomerWidget(true);
        }}
        classNames="btn btn--primary ml-auto"
      >
        <PlusIcon style={{ fontSize: "20px" }} className="mr-1" />
        Add Customers
      </primaryComponents.Button>

      <section className={`${globalStyles.cardWithBorder} overflow-hidden p-0`}>
        <div className={globalStyles.tableHeader}>
          <primaryComponents.SearchField
            classNames={globalStyles.searchField}
            placeholder="Search by Customer name or phone number"
            trigger={(value) => searchCustomers(value)}
            value={search.get("query") !== null ? search.get("query") : ""}
            triggerOnInput={true}
            showsearchBtn={true}
          />
        </div>

        <secondaryComponents.LoaderHelper
          isLoading={isFetchingCustomers}
          classNames="my-5"
        >
          <secondaryComponents.LoaderHelper
            classNames={"mt-5"}
            isLoading={isFetchingCustomers}
          >
            <secondaryComponents.CustomersTable
              isViaSellMode={true}
              customers={customers}
              metaDetails={metaDetails}
              gotoPage={gotoPage}
            />
          </secondaryComponents.LoaderHelper>
        </secondaryComponents.LoaderHelper>
      </section>

      {/* customer widget */}
      <secondaryComponents.Modal
        isActive={isCustomerWidget}
        closeModal={() => setIsCustomerWidget(false)}
        width={"600px"}
      >
        <secondaryComponents.AddCustomerWidgetModal
          closeModal={() => setIsCustomerWidget(false)}
          customers={customers}
          isEditMode={false}
        />
      </secondaryComponents.Modal>
    </RoutedModal>
  );
};
